import React from 'react';
import { EXTRA_CUSTOMIZATION_COLORS } from 'cards/constants/ExtraCustomization';
import {
  Container,
  Title,
  Subtitle,
  Grid,
  GridItem,
  Color,
} from './ExtraCustomizationColorsModal.styles';

const ExtraCustomizationColorsModal = (): JSX.Element | null => {
  return (
    <Container>
      <Title>
        We recommend these{' '}
        <span role="img" aria-label="colors">
          🎨
        </span>
      </Title>
      <Subtitle>They print beautifully and clearly. Choose in the next step.</Subtitle>
      <Grid>
        {EXTRA_CUSTOMIZATION_COLORS.map(color => (
          <GridItem key={color.value}>
            <Color value={color.value} />
          </GridItem>
        ))}
      </Grid>
    </Container>
  );
};

export default {
  component: ExtraCustomizationColorsModal,
  options: {
    bottomModalOnMobile: true,
    size: 'md',
  },
};
